const MONTHS_FR = ["JANVIER", "FEVRIER", "MARS", "AVRIL", "MAI", "JUIN", "JUILLET", "AOUT", "SEPTEMBRE", "OCTOBRE", "NOVEMBRE", "DECEMBRE"];
const fold = (s) => (s || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().trim();
const iso = (d) => d.toISOString().slice(0, 10);

// Période de comparaison : dates personnalisées → période précédente de même durée ; 1 mois (+ année) → mois précédent.
// Retourne { params: {date_from,date_to} | {mois,annees}, label } ou null.
export function prevPeriod(f) {
  if (f.date_from && f.date_to) {
    const d1 = new Date(f.date_from), d2 = new Date(f.date_to);
    if (isNaN(d1) || isNaN(d2) || d2 < d1) return null;
    const days = Math.round((d2 - d1) / 86400000) + 1;
    const p2 = new Date(d1); p2.setUTCDate(p2.getUTCDate() - 1);
    const p1 = new Date(p2); p1.setUTCDate(p1.getUTCDate() - days + 1);
    return { params: { date_from: iso(p1), date_to: iso(p2) }, label: "vs période préc. (même durée)" };
  }
  const mois = (f.mois || []).map(fold);
  const annee = Number((f.annees || [])[0]);
  if (mois.length === 1 && MONTHS_FR.includes(mois[0]) && annee) {
    const i = MONTHS_FR.indexOf(mois[0]);
    const pm = MONTHS_FR[(i + 11) % 12], py = i === 0 ? annee - 1 : annee;
    return { params: { mois: pm, annees: py }, label: "vs mois préc." };
  }
  if (!mois.length && f.exercice && /^(\d{4})-(\d{4})$/.test(f.exercice)) {
    const [, a, b] = f.exercice.match(/^(\d{4})-(\d{4})$/);
    return { params: { exercice: `${+a - 1}-${+b - 1}` }, label: `vs exercice ${+a - 1}-${+b - 1}` };
  }
  if (!mois.length && (f.annees || []).length === 1 && annee) {
    return { params: { annees: annee - 1 }, label: `vs ${annee - 1}` };
  }
  return null;
}

// Vrai si la sélection couvre plus d'un mois (→ les cards doivent cumuler la période, comme les tableaux)
export function isMultiMonth(f) {
  if (f.date_from && f.date_to) return f.date_from.slice(0, 7) !== f.date_to.slice(0, 7);
  const n = (f.mois || []).length;
  if (n > 1) return true;
  if (n === 1) return false;
  return !!(f.exercice || (f.annees || []).length);
}

// Variation en % (ou en points si pt=true) formatée, null si non calculable
export function deltaText(cur, prev, { pt = false, digits = 1 } = {}) {
  if (cur == null || prev == null || isNaN(cur) || isNaN(prev)) return null;
  if (!pt && !prev) return null;
  const v = pt ? (cur - prev) * 100 : ((cur - prev) / Math.abs(prev)) * 100;
  const s = `${v > 0 ? "+" : ""}${v.toFixed(digits).replace(".", ",")}${pt ? " pt" : "%"}`;
  return { text: s, value: v };
}
